import React from 'react';
import { formatDate, formatCurrency } from '../../utils/Utils';
import Badge from '../badge/Badge';
import { useNavigate } from 'react-router-dom';

function TestataOrdine({ data }) {
    const navigate = useNavigate();

    const handleRowClick = () => {
        navigate(`/dettaglioOrdine/${data.idordine}`);
    };

    return (
        <tr onClick={handleRowClick} style={{ cursor: 'pointer' }}>
          <td>{data.dataexport !== "" ? <Badge text={"Inviato al gestionale"} type={"bg-success"}/> : <Badge text={"Non inviato al gestionale"} type={"bg-danger"}/>}</td>
          <td className='text-center'>{data.idordine || ''}</td>
          <td className='text-center'>{formatDate(data.data) || ''}</td>
          <td className='text-start'>
            {formatDate(data.datainviogestionale) !== "01/01/1" && (
              <>
                {data.numordinegestionale || ''}
                <br />
                Inviato il: {formatDate(data.datainviogestionale) || ''}
              </>
            )}
          </td>

          <td>{data.consumer_nome || ''}</td>
          <td>{data.consumer_cognome || ''}</td>
          <td>{data.shipping_indirizzo ? `${data.shipping_indirizzo}, ${data.shipping_cap} - ${data.shipping_provincia}` : ''}</td>
		      <td className='text-end'>{formatCurrency(data.totregalo)}</td>
          <td className="text-end">{formatCurrency(data.totdapagare)}</td>
          <td className="text-end">{formatCurrency(data.totpagato)}</td>
          
        </tr>
      );
}

export default TestataOrdine;
